<div id="admin-menu-body">
    <div class="tab-title">Client Information</div>
    <div *ngIf="initControlsFlag" class="form-section" [formGroup]="clientDetails">
        <!-- Company Full Name -->
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Client Name</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="fullName"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="fullName" [name]="'Name'"></validator>

        <!-- Company Short Name -->
        <mat-form-field *ngIf="action != 'Edit'" class="form-field" appearance="outline">
            <mat-label>Client Short Name</mat-label>
            <input
                (change)="updateShortName()"
                [readonly]="action === 'View'"
                matInput
                formControlName="shortName"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="shortName" [name]="'Name'"></validator>

        <mat-form-field *ngIf="action != 'Edit'" class="form-field" appearance="outline">
            <mat-label>ClientKey</mat-label>
            <input
                (change)="updateClientKey()"
                [readonly]="action === 'View' || action === 'Edit'"
                matInput
                formControlName="clientKey"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="clientKey" [name]="'ClientKey'"></validator>
        <div class="form-control-block-small">
            <div class="client-detail-control">
                <div class="recordView-label">Entity Classification</div>
                <select
                    class="details-recordView-input-ddl"
                    formControlName="entityClassification"
                    name="entityClassification"
                    disabled="{{ action === 'View' ? 'disabled' : '' }}"
                >
                    <option
                        *ngFor="let entityClassification of entityClassificationList"
                        [value]="entityClassification"
                        [disabled]="action === 'View'"
                    >
                        {{ entityClassification }}
                    </option>
                </select>
                <validator
                    class="details-validator"
                    [control]="entityClassification"
                    [name]="'EntityClassification'"
                    [errorMessageStyle]="'error-message2'"
                ></validator>
            </div>
        </div>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Customer Number</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="customerNumber"
                type="text"
                outlined
            />
        </mat-form-field>
        <!-- Company Url -->
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Client Website</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="companyURL"
                type="text"
                outlined
            />
            <validator [control]="companyURL" [name]="'URL'"></validator>
        </mat-form-field>

        <!-- Hubspot Url -->
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>HubSpot URL</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="hubSpotUrl"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="hubSpotUrl" [name]="'URL'"></validator>

        <!-- Compensafe URL -->
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>CompenSafe URL</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="compenSafeUrl"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="compenSafeUrl" [name]="'URL'"></validator>

        <!-- Compensafe Company ID -->
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>CompenSafe Company ID</mat-label>
            <input
                [readonly]="action === 'View'"
                matInput
                formControlName="cS_CompanyID"
                type="text"
                outlined
            />
        </mat-form-field>
        <validator [control]="cS_CompanyID" [name]="'ID'"></validator>

        <!-- Swap Key -->
        <mat-form-field class="form-field" appearance="outline" *ngIf="action === 'View'">
            <mat-label>Data Swap Key</mat-label>
            <input [readonly]="true" matInput [value]="dataSwapKey" type="text" outlined />
        </mat-form-field>

        <!-- Contract Date -->
        <div class="client-edit-dates">
            <mat-label>Contract Date</mat-label>
            <input [readonly]="action === 'View'" matInput hidden />
            <kendo-datepicker
                class="no-border kendoDatePicker"
                format="MM/dd/yyyy"
                formControlName="contractDate"
                required
            ></kendo-datepicker>
            <validator [control]="contractDate" [name]="'Date'" [topOffset]="5"></validator>
        </div>

        <!-- Launch Date -->
        <div class="client-edit-dates">
            <mat-label>Launch Date</mat-label>
            <input [readonly]="action === 'View'" matInput hidden />
            <kendo-datepicker
                class="no-border kendoDatePicker"
                format="MM/dd/yyyy"
                formControlName="goLiveDate"
            ></kendo-datepicker>
        </div>

        <!-- Loan Seed Date -->
        <div class="client-edit-dates">
            <mat-label>Loan Seed Date</mat-label>
            <input [readonly]="action === 'View'" matInput hidden />
            <kendo-datepicker
                class="no-border kendoDatePicker"
                format="MM/dd/yyyy"
                formControlName="loanSeedDate"
                required
            ></kendo-datepicker>
            <validator [control]="loanSeedDate" [name]="'Date'" [topOffset]="5"></validator>
        </div>

        <!-- Subscription Type -->
        <div class="formControlBlock" style="padding-top: 40px">
            <div class="quickview-label">Subscription Type</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ clientModel.clientDetails.subscriptionType }}
            </div>
            <div *ngIf="action !== 'View'">
                <select class="select-light-border-38" formControlName="clientSubscriptionTypeKey">
                    <option
                        *ngFor="let subscriptionType of subscriptionTypeList"
                        [value]="subscriptionType.clientSubscriptionTypeKey"
                    >
                        {{ subscriptionType.name }}
                    </option>
                </select>
                <validator
                    [control]="clientSubscriptionTypeKey"
                    [name]="'Subscription Type'"
                    [topOffset]="10"
                ></validator>
            </div>
        </div>

        <!-- NV-Lite -->
        <div class="formControlBlock">
            <div class="quickview-label">NV Base</div>
            <div class="recordView-value" *ngIf="action !== 'Add'">
                {{ clientModel.clientDetails.nvLite == true ? 'Yes' : 'No' }}
            </div>
            <div *ngIf="action === 'Add'">
                <input
                    type="radio"
                    formControlName="is_nvlite"
                    value="true"
                    (ngModelChange)="updateNvLiteSettings($event)"
                />
                Yes
                <input
                    type="radio"
                    formControlName="is_nvlite"
                    value="false"
                    (ngModelChange)="updateNvLiteSettings($event)"
                />
                No
            </div>
        </div>

        <!-- Authentication Method -->
        <div class="formControlBlock">
            <div class="quickview-label">Authentication Method</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{
                    useSSO?.value === 'Both'
                        ? 'Both'
                        : useSSO?.value === 'false'
                        ? 'Username and Password'
                        : 'MSFT Azure AD'
                }}
            </div>
            <div *ngIf="action !== 'View'">
                <input type="radio" formControlName="useSSO" value="true" />MSFT Azure AD
                <input type="radio" formControlName="useSSO" value="false" />Username and Password
                <input type="radio" formControlName="useSSO" value="Both" />Both
                <validator [control]="useSSO" [name]="'Authentication Method'"></validator>
            </div>
        </div>
        <!-- Use Hourly KPI -->
        <div class="formControlBlock">
            <div class="quickview-label">Use Hourly KPI</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ use_Hourly_KPI?.value == 'true' ? 'Enabled' : 'Disabled' }}
            </div>
            <div *ngIf="action !== 'View'">
                <input type="radio" formControlName="use_Hourly_KPI" value="true" />
                Enable
                <input type="radio" formControlName="use_Hourly_KPI" value="false" />
                Disable
            </div>
        </div>
        <div class="formControlBlock">
            <div class="item-area">
                <div class="item-label">Active</div>
                <p-checkbox
                    class="item-checkbox"
                    formControlName="isActive"
                    [binary]="true"
                    [disabled]="action === 'View'"
                />
                <validator [control]="isActive" [name]="'Active status'"></validator>
            </div>
        </div>
        <div class="formControlBlock">
            <div class="item-area">
                <div class="item-label">Login disabled</div>
                <p-checkbox
                    class="item-checkbox"
                    formControlName="isLoginDisabled"
                    [binary]="true"
                    [disabled]="action === 'View'"
                />
                <validator [control]="isLoginDisabled" [name]="'Login disabled status'"></validator>
            </div>
        </div>
    </div>
</div>
